// ScrapersPage.tsx - Main scrapers page
import { Container, Tabs } from '@mantine/core';
import { IconDashboard, IconHistory } from '@tabler/icons-react';
import { ScraperDashboard } from '@/components/scrapers/ScraperDashboard';
import { ScraperHistory } from '@/components/scrapers/ScraperHistory';
import { useState } from 'react';

export function ScrapersPage() {
  return (
    <Container size="xl" py="xl">
      <Tabs defaultValue="dashboard">
        <Tabs.List>
          <Tabs.Tab value="dashboard" leftSection={<IconDashboard size={16} />}>
            Dashboard
          </Tabs.Tab>
          <Tabs.Tab value="history" leftSection={<IconHistory size={16} />}>
            History
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="dashboard" pt="xl">
          <ScraperDashboard />
        </Tabs.Panel>

        <Tabs.Panel value="history" pt="xl">
          <ScraperHistory />
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
}
